import { CookiesStorageService } from '@/services/cookiesStorageService';
import { ENV } from '@/constants/env';
import { GOOGLE_ID } from '@/constants/googleEvents';

export const generateClientId = () => {
	if (window.gtag && !CookiesStorageService.get(GOOGLE_ID.CLIENT_ID, '')) {
		(window.gtag as any)(
			'get',
			ENV.GTAG_ID,
			GOOGLE_ID.CLIENT_ID,
			(clientID: string) => {
				CookiesStorageService.set(GOOGLE_ID.CLIENT_ID, clientID, { path: '/' });
				return clientID;
			},
		);
	}
	return CookiesStorageService.get(GOOGLE_ID.CLIENT_ID, '');
};
